export default __webpack_public_path__ + "static/media/SourceSansProItalic.19783ae8.ttf";